<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="300"
      size="mini"
      resizable
      border
      round
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">包装箱记录</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              size="sm"
              class="mr-2"
              variant="outline-success"
              :disabled="disabled"
              @click="openEditBoxDialog({ type: 'add', code: 'A', row: {} })"
            >
              <b-icon-plus></b-icon-plus>新增散箱
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              :disabled="disabled"
              @click="openEditBoxDialog({ type: 'add', code: 'B', row: {} })"
            >
              <b-icon-plus></b-icon-plus>新增托盘
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              v-if="!disabled"
              placement="top"
            >
              <i
                class="el-icon-edit tool-btn"
                @click="
                  openEditBoxDialog({
                    type: 'edit',
                    code: row.packageType,
                    row: row,
                  })
                "
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              v-if="!disabled"
              placement="top"
            >
              <i class="el-icon-delete tool-btn" @click="del(row)"></i>
            </el-tooltip>
          </b-button-group>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 90,
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'packageTypeName',
          title: '包装类型',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'packageNo',
          title: '包装编号',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'packageLength',
          title: '长',
          headerAlign: 'center',
          align: 'center',
          minWidth: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'packageWidth',
          title: '宽',
          headerAlign: 'center',
          align: 'center',
          minWidth: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'packageHeight',
          title: '高',
          headerAlign: 'center',
          align: 'center',
          minWidth: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'packageVolume',
          title: '体积',
          headerAlign: 'center',
          align: 'center',
          minWidth: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'packageQty',
          title: '件数',
          headerAlign: 'center',
          align: 'center',
          minWidth: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'boxQty',
          title: '箱数',
          headerAlign: 'center',
          align: 'center',
          minWidth: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'subVolume',
          title: '总体积',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'subVolumeWeight',
          title: '总体积重',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: 'ellipsis',
        },
        {
          field: 'subWeight',
          title: '称重重量',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'subPriceWeight',
          title: '计费重量',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },
  methods: {
    openEditBoxDialog(params) {
      if (params.row.packageNo) {
        let index = this.$refs.table.getRowIndex(params.row)
        params.row.index = index
      }
      this.$emit('openEditBoxDialog', params)
    },
    del(row) {
      this.$confirm('您确定要删除该数据吗?').then((type) => {
        if (type === 'confirm') {
          let index = this.$refs.table.getRowIndex(row)
          this.tableData.splice(index, 1)
        }
      })
      this.$emit('update:tableData', this.tableData)
    },
  },
}
</script>
